import { render } from "./ExtractView.vue?vue&type=template&id=2ea5e4b1&scoped=true"
import script from "./ExtractView.vue?vue&type=script&lang=js"
export * from "./ExtractView.vue?vue&type=script&lang=js"

import "./ExtractView.vue?vue&type=style&index=0&id=2ea5e4b1&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea5e4b1"]])

export default __exports__